import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import ColorPickerViewModel from '@/ViewModels/Controls/ColorPickerViewModel';
import ColorPicker from '@/Controls/ColorPicker';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class ColorPickerFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private ColorPickerViewModel = ComponentManager.getViewModel<typeof ColorPickerViewModel>('ColorPickerViewModel');
    private ColorPicker = ComponentManager.getControl<typeof ColorPicker>('ColorPicker');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel')

    /**
     * @override
     */ 
    public viewModel: ColorPickerViewModel;

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    control: ColorPicker;

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = this.detailViewItem.viewModel || new this.ColorPickerViewModel({
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            isFocusable: this.isFocusable,
            invalidationText: this.invalidationText,
            value: this.context.genericObject.getObservable(this.detailViewItem.name)
        })

        this.control = new this.ColorPicker(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.addOverwritableToControl(this.jQueryControl, [this.detailViewItem.name]);
        this.registerDefaultValidation([this.detailViewItem.name]);

        return this.jQueryControl;
    }
}

ComponentManager.setFactory('ColorPicker', ColorPickerFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');